import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

import {
  Button,
  Modal,
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
  OutlinedInput,
  InputLabel,
  FormControl,
} from "@mui/material";

export default function DiscountModal({
  open,
  handleClose,
  bill,
  setBill,
  setOpen,
}) {
  const [data, setData] = React.useState({
    discount: "",
    discountType: "Amount",
    paybill: "",
  });

  const limitAmountAccept = {
    Amount: (val, value) => {
      return value < val;
    },
    Percent: (per, value) => {
      return 100 >= value;
    },
  };
  const discountType_call = {
    Amount: (val, value) => {
      return val - Number(value);
    },
    Percent: (val, value) => {
      return val - val * (Number(value) / 100);
    },
  };
  React.useEffect(() => {
    if (bill) {
      // console.log("billdata== discount ", bill, " ", bill.discount);
      setData({ ...bill, paybill: bill.paybill });
    }
  }, [bill]);
  const displayAmount = () => {
    return bill.amount
      ? bill.amount
      : (function () {
          let sum = 0;
          bill?.counterSalesChild?.forEach((item) => {
            sum += item.amount;
          });

          return sum;
        })();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "40%", md: "40%", lg: "30%", xl: "30%" },

          position: "absolute",
          left: { xs: "2%", sm: "35%", md: "35%", lg: "35%", xl: "35%" },

          top: "30%",
        }}
      >
        <Box sx={{ backgroundColor: "#C0BFFF", mb: 2 }}>
          <CloseIcon
            sx={{
              fontSize: "28px",
              float: "right",
              m: "10px",
              cursor: "pointer",
            }}
            onClick={() => {
              setOpen(false);
            }}
          />
          <Typography
            sx={{
              p: "10px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
              fontWeight: 500,
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
            color="primary"
          >
            Discount
          </Typography>
        </Box>
        <Box
          sx={{
            p: "10px",
          }}
        >
          <Grid container>
            <Grid item xs={12}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel
                  sx={{
                    fontWeight: 500,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                >
                  Bill Amount
                </InputLabel>
                <OutlinedInput
                  value={displayAmount()}
                  readOnly
                  label="Bill Amount"
                  sx={{
                    textAlign: "right",
                    fontWeight: 500,
                    fontSize: 15,
                    color: "#000",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "2px solid #01008BA8",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#01008BA8",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#01008BA8",
                    },
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Typography
                textAlign="left"
                sx={{
                  pt: "10px",
                  fontWeight: 600,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },

                  color: "#000",
                }}
                onClick={() => setOpen(true)}
              >
                Discount Type
              </Typography>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={data.discountType}
                onChange={(e) => {
                  setData({
                    ...data,
                    discountType: e.target.value,
                    discount: 0,
                    paybill: bill?.amount,
                  });
                  // setBill({
                  //   ...bill,
                  //   discountType: e.target.value,
                  //   discount: 0,
                  // });
                }}
              >
                <FormControlLabel
                  value="Amount"
                  selected={true}
                  control={<Radio />}
                  label="Amount"
                  InputLabelProps={{
                    sx: {
                      color: "#545454",
                      fontWeight: 400,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingX: "7px",
                    },
                  }}
                  sx={{
                    color: "#01008B",
                    fontWeight: 500,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                />
                <FormControlLabel
                  value="Percent"
                  control={<Radio />}
                  label="Percentage"
                  sx={{
                    color: "#01008B",
                    fontWeight: 500,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                />
              </RadioGroup>
              <TextField
                fullWidth
                id="BrifeAddress"
                size="small"
                label="Discount"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      border: "2px solid #01008BA8",
                    },
                    "&:hover fieldset": {
                      borderColor: "#01008BA8",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#01008BA8",
                    },
                  },
                  width: "100%",
                  fontWeight: 500,
                  my: 2,
                }}
                name="BrifeAddress"
                value={data.discount ? data.discount : ""}
                onChange={(e) => {
                  let val = displayAmount();
                  let per;
                  // console.log("billData ", bill);

                  per = discountType_call[data?.discountType](
                    val,
                    e.target.value
                  );

                  if (
                    limitAmountAccept[data?.discountType](val, e.target.value)
                  ) {
                    setData((prev) => {
                      return {
                        ...prev,
                        discount: e.target.value,
                        paybill: per,
                      };
                    });
                  }
                  // if (
                  //   bill.discountType === "Percent" &&
                  //   e.target.value <= 100
                  // ) {
                  //   let per = val - (Number(e.target.value) / 100) * val;

                  //   setBill({
                  //     ...bill,

                  //     ...(!isNaN(bill.paybill) ? { paybill: per } : {}),
                  //     discount: e.target.value,
                  //   });
                  // }
                  // if (bill.discountType === "Amount" && e.target.value <= val) {
                  //   let per = val - Number(e.target.value);

                  //   setBill({
                  //     ...bill,
                  //     ...// bill.paybill !== NaN
                  //     (!isNaN(bill.paybill) ? { paybill: per } : {}),
                  //     discount: e.target.value,
                  //   });
                  // }
                }}
              />

              <Box
                sx={{
                  border: "2px solid #01008BA8", // ✅ 2px border directly
                  padding: "7px 14px",
                  borderRadius: "4px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "4px",
                  "&:hover": {
                    borderColor: "#01008BA8",
                  },
                }}
              >
                <Typography
                  sx={{
                    color: (theme) => theme.palette.primary.main,
                    fontWeight: "600",
                  }}
                >
                  Payable Amount :
                </Typography>
                <Typography
                  sx={{
                    color: "#01008B",
                    fontWeight: 600,
                    fontSize: 15,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <CurrencyRupeeIcon sx={{ fontSize: "17px", mr: 0.3 }} />
                  {data.paybill !== null && data.paybill !== undefined
                    ? data.paybill
                    : "t"}
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Button
            variant="contained"
            sx={{
              width: "100%",
              mt: "10px",
            }}
            onClick={() => {
              setOpen(false);
              setBill(data);
            }}
          >
            {" "}
            Apply
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
